module.exports = __webpack_public_path__ + "img/follow.8aff579b.jpg";